/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-cycle
import { ErrorData } from '@types';

export type UserActivity = {
  timeout: number;
  isIdle: boolean;
  error: null | ErrorData;
};

const initialState: UserActivity = {
  timeout: 0,
  isIdle: false,
  error: null,
};

const userActivitySlice = createSlice({
  name: 'userActivitySlice',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    fetchUserActivityTimeout() {},
    fetchUserActivityTimeoutSuccess(state, action: PayloadAction<number>) {
      state.timeout = action.payload;
    },
    fetchUserActivityTimeoutFailure(state, action: PayloadAction<ErrorData>) {
      state.error = action.payload;
      state.timeout = -1;
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    fetchUserActivityTimeoutFulfill() {},
    setIsIdle(state, action: PayloadAction<boolean>) {
      state.isIdle = action.payload;
    },
  },
});

export default userActivitySlice.reducer;

export const {
  fetchUserActivityTimeout,
  fetchUserActivityTimeoutFailure,
  fetchUserActivityTimeoutFulfill,
  fetchUserActivityTimeoutSuccess,
  setIsIdle,
} = userActivitySlice.actions;
